import { render, staticRenderFns } from "./ReportDetailCard.vue?vue&type=template&id=4b4ff8f2&"
import script from "./ReportDetailCard.vue?vue&type=script&lang=js&"
export * from "./ReportDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailCard.vue?vue&type=style&index=0&id=4b4ff8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports